import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { MaterialModule } from 'src/app/core/material.module';

import { AbilityService } from 'src/app/core/services/ability/ability.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { RootAnnotation } from 'src/app/features/working-area/interfaces';
import { DepartmentSelectComponent } from '../../../departments/components/department-select/department-select.component';
import { ReferringDoctorService } from '../../services/referring-doctors.service';
import { trackFeatureUse } from 'src/app/core/analytics';

@Component({
  selector: 'app-add-referring-doctors-dialog',
  templateUrl: 'add-referring-doctors-dialog.component.html',
  styleUrls: ['add-referring-doctors-dialog.component.scss'],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    DepartmentSelectComponent,
  ],
})
export class AddReferringDoctorsDialogComponent implements OnInit {
  form: FormGroup;
  public isLoading: boolean;
  isDepartmentDisabled: boolean = false;
  constructor(
    public ability: AbilityService,
    private notificationService: NotificationService,
    public referringDoctorService: ReferringDoctorService,
    public dialogRef: MatDialogRef<AddReferringDoctorsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RootAnnotation,

  ) {}

  ngOnInit() {
    this.form = new FormGroup({
      name: new FormControl('', [Validators.required]),
       phone: new FormControl('', [
      ]),
      fax: new FormControl('', [
      ]),
      departmentId: new FormControl('', []),
    });


    if (!this.ability.isDepartmentVisible) {
      this.form.patchValue({
        departmentId: this.ability.departmentId,
      });
      this.isDepartmentDisabled = true;
    }
  }

  onDepartmentChange(value: string) {
    this.form.get('departmentId')?.setValue(value);
  }

  onClose() {
    this.dialogRef.close();
  }

  save() {
    trackFeatureUse('referring_doctors', 'saved');
    this.isLoading = true;
    const payload = this.form.value;
    if (this.form.invalid) {
      this.isLoading = false;
      return;
    }

    this.referringDoctorService.create(payload).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.dialogRef.close(res);
        this.notificationService.success(
          'Created SuccessFully referring doctor'
        );
      },
      error: (err) => {
        this.dialogRef.close(null);
        this.notificationService.error('Error in creating referring doctor');
        this.isLoading = false;
      },
    });
  }
}
